import axios, { AxiosError, AxiosInstance } from 'axios';

export const isAxiosError = (candidate: any): candidate is AxiosError => {
  return candidate.isAxiosError === true;
};

const instance: AxiosInstance = axios.create({
  baseURL: window.SAVINGSCALCULATOR_API_ROOT,
  timeout: 3000,
});

export default instance;
